<template>
	<div class="unsubmit">
		<vs-row>
			<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="9" class="mb-4 p-d">
				<el-date-picker
					style="width:36%"
					v-model="yearmonth"
					format="yyyy-MM"
					value-format="yyyy-MM"
					placeholder="请选择月份"
					type="month">
				</el-date-picker>
				<el-input v-model="name" style="width:320px" placeholder="请输入姓名" class="ml-8 mr-4"></el-input>
				<el-cascader style="width:55%" v-model="deptid" :options="options" placeholder="请选择部门"
				             :props="{ checkStrictly: true,value:'id',label:'name'}" class="ml-8 mr-8"></el-cascader>
				<el-select v-model="type" placeholder="请选择">
					<el-option label="未提交用户" :value="1"></el-option>
					<el-option label="审核员用户" :value="2"></el-option>
				</el-select>
			</vs-col>
			<vs-col vs-type="flex" vs-align="center" vs-w="3" class="mb-4">
				<vs-button color="primary" type="filled" class="mr-4" @click="search">搜索</vs-button>
				<vs-button color="danger" type="filled" class="" @click="sendcode('')">一键提醒</vs-button>
			</vs-col>
		</vs-row>
		<vs-table ref="table" multiple :max-items="10" :data="memberlist" v-model="selected">
			<template slot="thead">
				<vs-th>ID</vs-th>
				<vs-th>姓名</vs-th>
				<vs-th>性别</vs-th>
				<vs-th>手机号</vs-th>
				<vs-th>部门</vs-th>
				<vs-th>月份</vs-th>
				<vs-th>状态</vs-th>
				<vs-th>操作</vs-th>
			</template>
			<template slot-scope="{data}">
				<tbody>
				<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
					<vs-td>
						<p class="product-name font-medium">{{ tr.id }}</p>
					</vs-td>
					<vs-td>
						<p class="product-category">{{ tr.name }}</p>
					</vs-td>
					<vs-td>
						<p class="product-price">{{ tr.sex == 0 ? '未知' : tr.sex == 1 ? '男' : '女' }}</p>
					</vs-td>
					<vs-td>
						<p class="product-price">{{ tr.phone }}</p>
					</vs-td>
					<vs-td>
						<p class="product-price">{{ tr.deptName }}</p>
					</vs-td>
					<vs-td>
						<p class="product-price">{{ tr.year }}</p>
					</vs-td>
					<vs-td>
						<p class="product-price text-success" v-if="!tr.count">未提交</p>
						<p class="product-price text-success" style="text-decoration:underline"
						   @click.stop="lookp(tr.id)" v-if="tr.count">待审{{ tr.count }}份</p>
					</vs-td>
					<vs-td>
						<vs-button class="mr-4" color="danger" type="filled" @click="sendcode(tr.id)" size="small">
							消息提醒
						</vs-button>
					</vs-td>
				</vs-tr>
				</tbody>
			</template>
		</vs-table>
		<vs-pagination class="mt-4" :total="total" v-model="itemsPerPage"></vs-pagination>
	</div>
</template>
<script>
export default {
	data() {
		return {
			memberlist: [],
			total: 0,
			options: [],     //部门列表
			deptid: [],
			name: '',
			type: 1,
			yearmonth: "", //月份
			itemsPerPage: 1,
			selected: [], //选中
		}
	},
	mounted() {
		this.getoptions();
		this.getlist();
	},
	watch: {
		itemsPerPage: 'getlist'
	},
	methods: {
		getMonthEndDay(yearMonth) {
			const fullData = `${yearMonth}-01 00:00:00`
			let date = new Date(fullData)
			let year = date.getFullYear()
			let month = date.getMonth() + 1
			if (month > 12) {
				month = 1
				year++
			}
			if (month < 10) {
				month = "0" + month
			}
			let monthLastDay = new Date(year, month, 0).getDate();
			let firstDate = year + '-' + month + '-' + '01';
			let lastDate = year + '-' + month + '-' + monthLastDay;
			return {
				firstDay: `${firstDate} 00:00:00`,
				lastDay: `${lastDate} 23:59:59`
			}
		},
		lookp(userid) {   //查询待审核份数是哪些用户
			const that = this;
			const time = this.getMonthEndDay(this.yearmonth)
			this.$api.lookuser({
				userId: userid,
				startTime: time.firstDay,
				endTime: time.lastDay
			}).then(function (response) {
				console.log("人员：", response);
				if (response.code == 0) {
					let str = "";
					response.data.forEach((item) => {
						str = `<p style='display:flex;justify-content: space-around;'><span>姓名：${item.name}</span><span>手机号：${item.phone}</span></p>${str}`
					})

					that.$alert(str, '人员名单', {
						dangerouslyUseHTMLString: true,
						customClass: 'people'
					});
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},

		search() {
			this.itemsPerPage = 1;
			this.getlist();
		},
		removeEmptyChildren(node) {   //杀生
			var that = this;
			node.forEach(item => {
				if ('children' in item && item.children.length === 0) {
					delete item.children
				} else if ('children' in item && item.children.length) {
					that.removeEmptyChildren(item.children)
				}
			})
			return node;
		},
		getoptions() {	//获取部门列表
			const that = this;
			this.$api.getmember({}).then(function (response) {
				console.log("组织架构：", response);
				if (response.code == 0) {
					that.options = that.removeEmptyChildren(response.data);
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		getlist() {    //获取列表
			const thisIns = this;
			this.$api.getnosubmitlist({
				type: thisIns.type,
				assessTime: thisIns.yearmonth,
				deptId: thisIns.deptid[thisIns.deptid.length - 1],
				name: thisIns.name,
				pageNum: thisIns.itemsPerPage,
				pageSize: 10,
				status: 1
			}).then(function (response) {
				console.log("列表数据：", response);
				if (response.code == 0) {
					thisIns.memberlist = response.data.data;
					thisIns.total = response.data.pages;
				} else {
					thisIns.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		sendcode(id) {
			const that = this;
			var ids;
			if (id) {
				ids = id;
			} else {
				var arr = [];
				this.selected.forEach(item => {
					arr.push(item.id);
				})
				if (arr.length == 0) {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: "请勾选要发送提醒的用户",
						position: 'top-center'
					});
					return false;
				}
				ids = arr.join(",");
			}
			this.$api.sendcode({ids: ids, type: that.type}).then(function (response) {
				console.log("消息发送结果：", response);
				if (response.code == 0) {
					that.$vs.notify({
						title: "提示",
						color: 'success',
						text: response.message,
						position: 'top-center'
					});
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
	},
}
</script>
<style type="text/css">
.people .el-message-box__content {
	max-height: 400px;
	overflow: auto;
}
</style>
